<template>
	<AppButton
		:label="$t('settings.new-rule')"
		startIcon="assets/v2/image/icons/plus.svg"
        @click="onAddClick"
	/>
</template>

<script setup>
import { useShippingFeesLocationsStore } from '../../../stores/shipping-fees-locations';
import { useI18n } from 'vue-i18n';
import { Alert } from '@/v2/plugins/alert';

const { t } = useI18n();
const shippingFeesLocationsStore = useShippingFeesLocationsStore();

const onAddClick = () => {
	if (shippingFeesLocationsStore.rules.length === 10) {
		Alert.error(t('settings.you-cant-create-more-than-10-rules'));
		return;
	}
	shippingFeesLocationsStore.addNewRule();
};
</script>

<style lang="scss" scoped></style>
